import React, { useState } from "react";
import { Space, Select, Input } from "antd";

const NotificationFIlters = ({ filters, onFiltersChange }) => {
  const [searchField, setSearchField] = useState("sentTo");
  const searchBy = (
    <Select
      defaultValue="title"
      className="select-before"
      onChange={(value) => setSearchField(value)}
    >
      <Select.Option value="title">Title</Select.Option>
    </Select>
  );

  return (
    <Space size="large" wrap>
      <div>
        <Input.Search
          addonBefore={searchBy}
          placeholder="Search"
          onSearch={(term) =>
            onFiltersChange({ ...filters, title: term, searchField })
          }
        />
      </div>

      <div>
        Type :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 120 }}
          allowClear
          onChange={(value) => onFiltersChange({ ...filters, type: value })}
        >
          <Select.Option value={"ANNOUNCEMENT"}>Announcement</Select.Option>
          <Select.Option value={"PARCEL"}>Parcel</Select.Option>
          <Select.Option value={"FINANCE"}>Finance</Select.Option>
        </Select>
      </div>
    </Space>
  );
};

export default NotificationFIlters;
